import * as REDUX_TYPES from '../types'

export const setCurrentPlayTime = (currentPlayTime) => {
  return {
    type: REDUX_TYPES.REACTOR.CURRENT_PLAY_TIME,
    currentPlayTime
  }
}

